import { StyledSpinner } from './Spinner.styles';

export interface SpinnerProps {
  size?: string;
  'data-testid'?: string;
  variant: 'primary' | 'secondary';
  inLine?: boolean;
}

export const SPINNER_SIZES = {
  button: '14px',
  page: '40px',
} as const;

const SpinnerDefaultProps: SpinnerProps = {
  size: SPINNER_SIZES.button,
  variant: 'primary',
  'data-testid': 'spinner',
};

export const Spinner = (props: Partial<SpinnerProps>) => {
  const resolvedProps = { ...SpinnerDefaultProps, ...props };
  const { inLine, ...styledProps } = resolvedProps;

  return <StyledSpinner {...styledProps} $inLine={inLine} />;
};
